export default class {
	idAdesao
	constructor(idAdesao) {
		this.idAdesao = idAdesao
	}
}
